import { useCallback, useEffect, useRef, useState } from "react";
import { enqueueTaskOfType, getTasksOfType } from "../../api";

export const WorkersIndex = (props) => {
    const [currentType, setCurrentType] = useState(null);
    const [queue, setQueue] = useState(null);
    const [jsonInput, setJsonInput] = useState('{}');
    const [chat, setChat] = useState([]);
    const typeInputRef = useRef();
    const msgRef = useRef();

    const refreshQueue = useCallback(() => getTasksOfType(currentType).then(tasks => setQueue(tasks)), [currentType]);


    useEffect(() => {
        if (currentType) {
            setQueue(null);
            refreshQueue();
        }

        return undefined;
    }, [currentType, refreshQueue]);


    useEffect(() => {
        const key = window.setInterval(() => refreshQueue(), 1000);

        return () => window.clearInterval(key);
    }, [currentType, refreshQueue]);

    const loadTasks = (ev) => {
        ev.preventDefault();
        ev.stopPropagation();

        setCurrentType(typeInputRef.current.value);

        return false;
    }

    const enqueueTask = async () => {
        try {
            const data = JSON.parse(jsonInput);
            await enqueueTaskOfType(currentType, data);
            refreshQueue();
            alert("Success!");
        } catch (e) {
            alert(e?.message || e);
        }
    }

    const submitChat = async (ev) => {
        ev.preventDefault();
        ev.stopPropagation();

        const chat = "<Jonathan>: " + msgRef.current.value.trim();
        msgRef.current.value = "";


        const body = {
            "messages": [
                {
                    "role": "user",
                    "content": chat
                }
            ],
            "params": {
                temperature: 0.99,
                top_p: 0.75
            }
        };

        const jobData = await enqueueTaskOfType('chatbart', body);
        setChat(old => ([...old, { role: "user", key: 0 - jobData.key, text: chat }]))
        refreshQueue();

        return false;
    }

    useEffect(() => {
        if (currentType === 'chatbart' && queue) {
            let newTasks = [];

            for (const q of queue) {
                if (q.result?.output?.text && !chat.find(t => t.key === q.key) && !newTasks.find(t => t.key === q.key)) {
                    newTasks.push(q);
                }
            }

            if (newTasks.length) {
                const mapped = newTasks.map(t => ({ "role": "assistant", key: t.key, text: t.result.output.text }));
                setChat(old => ([...old, ...mapped]))
            }
        }
    }, [currentType, queue, chat]);

    /*{
        "messages": [
            {
                "role": "user",
                "content": "<Jonathan>: wheres ben"
            }
        ],
        "params": {}
    } */


    let validJson = false;

    try {
        JSON.parse(jsonInput);
        validJson = true;
    } catch {
        //
    }


    return (
        <div style={{ padding: 12 }}>
            <div>
                <form onSubmit={loadTasks}>
                    <input type="text" name="current-type" placeholder="Enter queue type to view" ref={typeInputRef} />
                    <button type="submit">Load</button>
                </form>
            </div>

            {queue !== null && <div>
                <h2>Task scheduling</h2>
                <textarea
                    value={jsonInput}
                    onChange={ev => setJsonInput(ev.currentTarget.value)}
                />

                <br />

                {validJson ? <><button onClick={enqueueTask}>Enqueue</button></> : "Invalid JSON input."}
            </div>}

            {/* <div>
                {
                    queue === null ? "Tasks not yet loaded..." :
                        <div>Wahey {queue.length} tasks<br />
                            {queue.map(task => <div>{JSON.stringify(task)}</div>)}
                        </div>
                }
            </div> */}

            <hr />

            <div>
                <h2>Chat thing</h2>

                <div>
                    <form onSubmit={submitChat}>
                        <input ref={msgRef} placeholder="Enter text to send as Jonathan..." />
                    </form>
                </div>

                <hr />

                <div>Message history</div>

                {[...chat].reverse().map(c => (

                    <div key={c.key}>
                        <pre>{c.text}</pre>
                    </div>

                ))}
            </div>
        </div>
    )
};
